module.exports = __webpack_public_path__ + "img/icon-home-buyer-guide-flyer.e1483ce3.svg";